"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createSubjectIndirectSubjects;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _createSubject = _interopRequireDefault(require("./createSubject"));

var _ensureIndirectSubjectId = _interopRequireDefault(require("./ensureIndirectSubjectId"));

function createSubjectIndirectSubjects(_x, _x2, _x3) {
  return _createSubjectIndirectSubjects.apply(this, arguments);
}

function _createSubjectIndirectSubjects() {
  _createSubjectIndirectSubjects = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(ctx, rule, discountProcuct) {
    var price,
        quantity,
        fixedPrice,
        _args = arguments;
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            price = _args.length > 3 && _args[3] !== undefined ? _args[3] : 0;
            quantity = _args.length > 4 && _args[4] !== undefined ? _args[4] : 1;
            fixedPrice = _args.length > 5 ? _args[5] : undefined;

            if (!(discountProcuct && (typeof discountProcuct === 'string' || (0, _typeof2.default)(discountProcuct) === 'object'))) {
              _context.next = 14;
              break;
            }

            _context.t1 = _ensureIndirectSubjectId.default;
            _context.t2 = rule;
            _context.next = 8;
            return (0, _createSubject.default)(ctx, {
              product: discountProcuct,
              price: price,
              quantity: quantity,
              fixedPrice: fixedPrice
            });

          case 8:
            _context.t3 = _context.sent;
            _context.t4 = (0, _context.t1)(_context.t2, _context.t3);
            _context.t5 = [_context.t4];
            _context.t0 = {
              indirectSubjects: _context.t5
            };
            _context.next = 15;
            break;

          case 14:
            _context.t0 = {};

          case 15:
            return _context.abrupt("return", _context.t0);

          case 16:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _createSubjectIndirectSubjects.apply(this, arguments);
}